export const GETDATA="GETDATA";
export const IMAGE="IMAGE";